module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Kirchberg-5f504f9769c3d42a19166746a0e880b2.png";